module.exports = __webpack_public_path__ + "img/text.3c92e19c.svg";